import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import environment from '../../../environment';
import GenerateVideoMutation from '../../../mutations/GenerateVideoMutation';
import { AccountVideoDownloadForm } from './AccountDownloadVideoForm';

import VideoNotReadyDialog from '../dialogs/VideoNotReadyDialog';
import AccountDownloadTileButton from './AccountDownloadTileButton';

const AccountDownloadTileVideo = ({
  icon,
  textInSpan,
  eventSgId,
  values,
  isFaceSearchEvent,
  notActive,
  intl,
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const hasOptions = values?.length > 1 && !isFaceSearchEvent;
  const [isVideoNotReadyDialogOpen, setIsVideoNotReadyDialogOpen] = useState(false);
  const [isVideoForFaceEventDialogOpen, setIsVideoForFaceEventDialogOpen] =
    useState(false);
  const initialValuesForAvailableZips = values?.map((value) => ({
    id: value,
    url: null,
  }));
  const [downloadableZipsData, setDownloadableZipsData] = useState(
    initialValuesForAvailableZips
  );

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    if (error) {
      setError(false);
    }
    setOpen(true);
  };

  const download = (url) => {
    window.location.href = url;
  };

  const updateState = (idToUpdate, newUrl) => {
    let stateCopy = [...downloadableZipsData];
    const indexToUpdate = stateCopy.findIndex((item) => item.id === idToUpdate);
    if (indexToUpdate !== -1) {
      stateCopy[indexToUpdate].url = newUrl;
      setDownloadableZipsData(stateCopy);
    }
  };

  const generateVideoDownloadLink = (startNumber) => {
    setIsPending(true);
    setOpen(false);
    GenerateVideoMutation.commit(environment, eventSgId, startNumber, (error, url) => {
      if (!error) {
        updateState(startNumber, url);
        download(url);
      } else {
        setError(true);
      }
      setIsPending(false);
    });
  };

  const defineMainAction = () => {
    if (notActive) {
      setIsVideoNotReadyDialogOpen(true);
      return;
    }
    if (isFaceSearchEvent) {
      setIsVideoForFaceEventDialogOpen(true);
      return;
    }
    if (hasOptions) {
      handleOpen();
      return;
    } else {
      handleButtonClicked(downloadableZipsData[0].id);
      return;
    }
  };

  const handleButtonClicked = (videoStartnumber) => {
    const videosData = downloadableZipsData.find((item) => item.id === videoStartnumber);
    if (videosData?.url) {
      download(videosData.url);
    } else generateVideoDownloadLink(videoStartnumber);
  };

  return (
    <>
      <AccountDownloadTileButton
        icon={icon}
        textInSpan={textInSpan}
        onClick={() => {
          defineMainAction();
        }}
        hasOpenedOptions={open}
        hasOptions={hasOptions}
        onCloseOptions={handleClose}
        isPending={isPending}
        error={error}
        notActive={notActive}
      >
        {open && (
          <div className="dropdown">
            {hasOptions &&
              values.map((availableVideo) => {
                return (
                  <button
                    key={availableVideo}
                    onClick={() => {
                      handleButtonClicked(availableVideo);
                    }}
                    className="dropdown-item"
                  >
                    <FormattedMessageWrappedInSpan
                      id="accountEventPage.products.bibNumber"
                      defaultMessage="Bib number"
                      className="dropdown-label"
                    />
                    <span>{availableVideo}</span>
                  </button>
                );
              })}
          </div>
        )}
      </AccountDownloadTileButton>
      <VideoNotReadyDialog
        open={isVideoNotReadyDialogOpen}
        onDialogClose={() => setIsVideoNotReadyDialogOpen(false)}
      />
      <AccountVideoDownloadForm
        eventSgId={eventSgId}
        open={isVideoForFaceEventDialogOpen}
        onDialogClose={() => setIsVideoForFaceEventDialogOpen(false)}
        intl={intl}
      />
    </>
  );
};

AccountDownloadTileVideo.propTypes = {
  icon: PropTypes.object,
  textInSpan: PropTypes.object,
  notActive: PropTypes.bool,
  eventSgId: PropTypes.number,
  values: PropTypes.array,
  isFaceSearchEvent: PropTypes.bool,
  intl: PropTypes.object,
};

export default AccountDownloadTileVideo;
